// composables/useToast.js
import { reactive } from 'vue'

const state = reactive({
    toasts: []
})

const DEFAULT_DURATION = 5000
const MAX_TOASTS = 5

const add = (options) => {
    if (state.toasts.length >= MAX_TOASTS) {
        remove(state.toasts[0].id)
    }

    const id = options.id || Date.now()
    const toast = {
        id,
        type: options.type || 'info',
        message: options.message,
        title: options.title,
        duration: options.duration ?? DEFAULT_DURATION,
        icon: options.icon,
        dismissible: options.dismissible ?? true
    }

    state.toasts.push(toast)

    if (toast.duration > 0) {
        setTimeout(() => {
            remove(id)
        }, toast.duration)
    }

    return id
}

const remove = (id) => {
    const index = state.toasts.findIndex(t => t.id === id)
    if (index !== -1) {
        state.toasts.splice(index, 1)
    }
}

const clear = () => {
    state.toasts.length = 0
}

const success = (message, options = {}) =>
    add({ ...options, type: 'success', message, icon: 'ep:success-filled' })

const error = (message, options = {}) =>
    add({ ...options, type: 'error', message, icon: 'ix:error-filled' })

const warning = (message, options = {}) =>
    add({ ...options, type: 'warning', message, icon: 'ep:warning-filled' })

const info = (message, options = {}) =>
    add({ ...options, type: 'info', message })

export const useToast = () => ({
    toasts: state.toasts,
    add,
    remove,
    clear,
    success,
    error,
    warning,
    info
})
